import { combineReducers } from "redux";

import stopFilters from "./stopFilters";
import stopListOrder from "./stopListOrder";
import selectedParcels from "./selectedParcels";
import { CLEAR_ALL } from "../../../actions/ui/routeDetail";

const routeDetails = combineReducers({
  stopFilters,
  stopListOrder,
  selectedParcels,
});

export default (state, action) => {
  switch (action.type) {
    case CLEAR_ALL: {
      return routeDetails({}, action);
    }

    default: {
      return routeDetails(state, action);
    }
  }
};
